"use strict";

module.exports = {
  BIOLOGICAL: 'BIOLOGICAL',
  EQUIPMENT: 'EQUIPMENT',
  PPE: 'PPE',
  SERVICES: 'SERVICES'
};